let inject = ['$q','$http', 'ngAuthSettings', 'AuthTokenFactory', 'SharedService', 'SessionService'];
class SalesService {
  constructor ($q, $http, ngAuthSettings, AuthTokenFactory, SharedService, SessionService) {
    this.$q = $q;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.AuthTokenFactory = AuthTokenFactory;
    this.SharedService = SharedService;
    this.SessionService = SessionService;
    this.dataFilters = null;
  }
  
  getProducts(data) {
    return this.$q((resolve, reject) => {
      this.$http({
        method: 'POST',
        url: this.ngAuthSettings.apiServiceBaseUri + '/categoria-info/show-items-by-cattegory',
        cache : false,
        data : data,
        headers: {'Content-Type': 'application/json'}
      }).then((response) => {
        resolve(response.data);
      }, reason => {
        console.log('reason');
        console.log(reason);
        console.log('reason');
        reject(reason);
      });
    });
    
  }
  
  getFiltersData () {
    return this.dataFilters;
  }
  
  setFiltersData (dataFilters) {
    this.dataFilters = dataFilters;
  }
  
}

SalesService.$inject = inject;

export default SalesService;



// WEBPACK FOOTER //
// ./www/components/catalog/sales/sales.service.js